
import { Product } from "@/types/product";

export const chassisProducts: Product[] = [
  {
    id: "front-wheel-hub",
    name: "FRONT WHEEL HUB",
    description: "Wheel hub assemblies that support wheel rotation and house the wheel bearings, ensuring smooth and stable movement. Engineered with premium-grade steel and corrosion-resistant coatings, our front hubs enhance wheel alignment, reduce friction, and extend bearing life for optimal performance.",
    images: ["/assets/front-hub/1.webp", "/assets/front-hub/2.webp", "/assets/front-hub/3.webp", "/assets/front-hub/4.webp"],
    certifications: ["ISO 9001:2015", "TS 16949"],
    minOrderQuantity: "100 units",
    availableFor: ["MARUTI", "HONDA", "ASHOK LEYLAND", "TATA"],
    shippingPorts: ["Dubai", "Mombasa", "Rotterdam"],
    metaDescription: "Trusted Front Wheel Hub exporter to Global Markets | ISO 9001:2015, TS 16949 Certified | 2024 Verified Supplier"
  },
  {
    id: "intermediate-shaft",
    name: "INTERMEDIATE SHAFT",
    description: "Rotating shafts that transfer torque between the transmission and drive axles, ensuring power is effectively delivered. Crafted from heat-treated steel alloys, our intermediate shafts offer excellent torsional strength, reducing vibrations and improving drivetrain efficiency.",
    images: ["/assets/intermediate-shaft/53.webp", "/assets/intermediate-shaft/54.webp", "/assets/intermediate-shaft/55.webp"],
    certifications: ["ISO 9001:2015"],
    minOrderQuantity: "100 units",
    availableFor: ["MARUTI", "HONDA", "HYUNDAI", "MAHINDRA"],
    shippingPorts: ["Dubai", "Mombasa", "Rotterdam"],
    metaDescription: "Trusted Intermediate Shaft exporter to Global Markets | ISO 9001:2015 Certified | 2024 Verified Supplier"
  },
  {
    id: "steering-knuckle",
    name: "STEERING KNUCKLE",
    description: "Essential components that connect the suspension and steering system, allowing the wheels to turn smoothly. Constructed from high-strength forged steel or aluminum, our steering knuckles provide excellent durability, precision, and impact resistance, ensuring reliable handling and stability.",
    images: ["/assets/steering-knuckle/44.webp", "/assets/steering-knuckle/45.webp", "/assets/steering-knuckle/46.webp"],
    certifications: ["ISO 9001:2015", "TS 16949"],
    minOrderQuantity: "100 units",
    availableFor: ["HYUNDAI", "MARUTI", "TATA", "HONDA", "MAHINDRA", "FORD", "CHEVROLET", "TOYOTA"],
    shippingPorts: ["Dubai", "Mombasa", "Rotterdam"],
    metaDescription: "Trusted Steering Knuckle exporter to Global Markets | ISO 9001:2015, TS 16949 Certified | 2024 Verified Supplier"
  }
];
